/* Video Reviews Section — vanilla JS.
   Play/pause per card + arrow scrolling. Safe when a card has no video. */
(function () {
  'use strict';

  function initVideoReviews(root) {
    var track = root.querySelector('[data-vr-track]');

    /* Play / pause buttons */
    root.querySelectorAll('[data-vr-card]').forEach(function (card) {
      var btn = card.querySelector('[data-vr-play]');
      var video = card.querySelector('video');
      if (!btn) return;
      if (!video) {
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', function () {
        if (video.paused) {
          // Pause every other video in this section first
          root.querySelectorAll('video').forEach(function (v) {
            if (v !== video) v.pause();
          });
          video.play();
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', function () {
        root.querySelectorAll('[data-vr-card]').forEach(function (c) {
          c.classList.toggle('is-playing', c === card);
        });
      });
      video.addEventListener('pause', function () {
        card.classList.remove('is-playing');
      });
    });

    /* Arrow navigation */
    root.querySelectorAll('[data-vr-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!track) return;
        var card = track.querySelector('[data-vr-card]');
        var step = card ? card.offsetWidth + 12 : 280;
        var dir = btn.getAttribute('data-vr-nav') === 'next' ? 1 : -1;
        // Jump to an exact card position so scroll-snap agrees with the target
        var index = Math.round(track.scrollLeft / step) + dir;
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var target = Math.min(max, Math.max(0, index * step));
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-video-reviews]').forEach(initVideoReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-video-reviews]');
    if (root) initVideoReviews(root);
  });
})();
